const canonicalName = (name) => name === 'DailyPredictionDate' ? 'Date' : name;
const active = (item) => {
  const value = item?.value;
  if (value == null || value === '') return false;
  if (typeof value === 'object') return Object.values(value).some((part) => part != null && part !== '');
  return true;
};

const migrateItems = (items) => {
  if (!Array.isArray(items)) return items;
  const result = [];
  items.forEach((item) => {
    if (!item?.name) return;
    const name = canonicalName(item.name);
    const index = result.findIndex((entry) => entry.name === name);
    const migrated = {...item, name};
    if (index === -1) result.push(migrated);
    else if (item.name === name) result[index] = migrated;
  });
  return result;
};

// Date is also the daily prediction date. Preserve saved settings without
// sending the retired alias or silently combining conflicting active filters.
export const migrateDataSearchPreference = (preference) => {
  const filters = Array.isArray(preference.filterValue) ? preference.filterValue : undefined;
  const legacy = filters?.find((item) => item?.name === 'DailyPredictionDate');
  const date = filters?.find((item) => item?.name === 'Date');
  const conflict = active(legacy) && active(date) &&
    JSON.stringify([legacy.operator, legacy.value]) !== JSON.stringify([date.operator, date.value]);
  const filterValue = migrateItems(filters);
  if (active(legacy) && !active(date)) {
    const index = filterValue.findIndex((item) => item.name === 'Date');
    filterValue[index] = {...legacy, name: 'Date'};
  }
  return {
    preference: {
      ...preference,
      columns: migrateItems(preference.columns),
      sortInfo: Array.isArray(preference.sortInfo)
        ? migrateItems(preference.sortInfo)
        : preference.sortInfo && {...preference.sortInfo, name: canonicalName(preference.sortInfo.name)},
      columnOrder: Array.isArray(preference.columnOrder)
        ? [...new Set(preference.columnOrder.map(canonicalName))] : preference.columnOrder,
      filterValue,
    },
    filterConflict: conflict
      ? 'Saved Date and Daily Prediction Date filters conflict. Edit or clear the Date filter to continue.'
      : null,
  };
};
